import { render, staticRenderFns } from "./award-task-block.vue?vue&type=template&id=18baca74&scoped=true&lang=pug&"
import script from "./award-task-block.vue?vue&type=script&lang=js&"
export * from "./award-task-block.vue?vue&type=script&lang=js&"
import style0 from "./award-task-block.vue?vue&type=style&index=0&id=18baca74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18baca74",
  null
  
)

export default component.exports